export { default as ExamplePage } from "./ExamplePage";
export { default as ExampleForm } from "./ExampleForm";



// WEBPACK FOOTER //
// ./src/components/example/index.js